/**
 * Configuration Index
 * Architecture v1 - Implementation Assets
 * 
 * Central export point for all configuration modules.
 */

// Field Visibility
export {
  MAIN_FRONTEND_FIELDS,
  ADVANCED_FRONTEND_FIELDS,
  BACKEND_ONLY_FIELDS,
  getFieldVisibility,
  getDisplayLabel as getFieldDisplayLabel,
  getFieldFormat,
  getMainFrontendFields,
  getAdvancedFrontendFields,
  getAllFrontendFields,
} from './fieldVisibility';

// Display Labels
export {
  DISPLAY_LABELS,
  getDisplayLabel,
  PAYMENT_STATUS_LABELS,
  BUREAU_LABELS,
  RESPONSIBILITY_LABELS,
  DISPUTE_STATUS_LABELS,
  DISPUTE_OUTCOME_LABELS,
} from './displayLabels';

// Reason Libraries
import reasonLibraryAccounts from './reasonLibrary_accounts.json';
import reasonLibraryOther from './reasonLibrary_other.json';
import reasonLibraryCompliance from './reasonLibrary_compliance.json';

export const REASON_LIBRARY = {
  ...reasonLibraryAccounts,
  ...reasonLibraryOther,
  ...reasonLibraryCompliance,
};

// Prompt Key Architecture
import promptKeyArchitecture from './promptKeyArchitecture.json';

export const ROUTING_STRATEGIES = promptKeyArchitecture.routing_strategies;
export const TEMPLATE_FAMILIES = promptKeyArchitecture.template_families;
export const PROMPT_KEYS = promptKeyArchitecture.prompt_keys;

// Utility: Get all reasons as flat array
export const getAllReasons = () => {
  const allCategories = [
    ...Object.values(reasonLibraryAccounts),
    ...Object.values(reasonLibraryOther),
    ...Object.values(reasonLibraryCompliance),
  ];
  return allCategories.flat();
};

// Utility: Get reason by key
export const getReasonByKey = (reasonKey) => {
  const allReasons = getAllReasons();
  return allReasons.find((r) => r.reason_key === reasonKey);
};

// Utility: Get reasons by category
export const getReasonsByCategory = (category) => {
  const library = { ...reasonLibraryAccounts, ...reasonLibraryOther, ...reasonLibraryCompliance };
  return library[category] || [];
};

// Utility: Get prompt key by key
export const getPromptKeyByKey = (key) => {
  return PROMPT_KEYS[key];
};

// Utility: Get routing strategy by key
export const getRoutingStrategy = (key) => {
  return ROUTING_STRATEGIES[key];
};

// Utility: Get template family by key
export const getTemplateFamily = (key) => {
  return TEMPLATE_FAMILIES[key];
};

// Utility: Find prompt keys for a reason
export const findPromptKeysForReason = (reasonKey) => {
  return Object.values(PROMPT_KEYS).filter(
    (pk) => pk.triggers.includes(reasonKey)
  );
};

// Export reason libraries individually for direct access
export { reasonLibraryAccounts, reasonLibraryOther, reasonLibraryCompliance };
